// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__GDbeU","left":"styles_left__1A-U0"};